import { DeleteItemsDialog } from '@retail/my-assortment/components';
import { useAssortmentItemsActions } from '@retail/my-assortment/context';
import { useCallback } from 'react';
import { format } from 'date-fns';

interface Props {
  assortmentId: number;
  itemsForDeletion: number[];
  resetCheckedItems: () => void;
}

export function DeleteItemsDialogContainer({
  assortmentId,
  itemsForDeletion,
  resetCheckedItems,
}: Props) {
  const { expireItems, expireItemsIsLoading } = useAssortmentItemsActions();

  const confirmDeleteCheckedItemsFromDate = useCallback(
    async (validTo?: Date) => {
      if (!itemsForDeletion.length) return;

      try {
        await expireItems({
          assortmentId,
          supplierItemIds: itemsForDeletion,
          validTo: validTo && format(validTo, 'yyyy-MM-dd'),
        });
        resetCheckedItems();
      } catch {
        return;
      }
    },
    [assortmentId, expireItems, itemsForDeletion, resetCheckedItems]
  );

  return (
    <DeleteItemsDialog
      isOpen={true}
      numberOfItems={itemsForDeletion.length}
      isDeleting={expireItemsIsLoading}
      onClose={resetCheckedItems}
      onDelete={confirmDeleteCheckedItemsFromDate}
    />
  );
}
